import React from "react"
import "./NavButton.css"

const NavButton = ({ className, children, onClick }) => (
  <div className={["navbutton", className].join(" ")} onClick={onClick}>
    {children}
  </div>
)

export default NavButton
